import { render, staticRenderFns } from "./PersonalMain.vue?vue&type=template&id=a3ded858&scoped=true"
import script from "./PersonalMain.vue?vue&type=script&lang=js"
export * from "./PersonalMain.vue?vue&type=script&lang=js"
import style0 from "./PersonalMain.vue?vue&type=style&index=0&id=a3ded858&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ded858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ded858')) {
      api.createRecord('a3ded858', component.options)
    } else {
      api.reload('a3ded858', component.options)
    }
    module.hot.accept("./PersonalMain.vue?vue&type=template&id=a3ded858&scoped=true", function () {
      api.rerender('a3ded858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal/PersonalMain.vue"
export default component.exports